﻿export function stop(e: Event) {
    e.preventDefault(); e.stopPropagation();
};  
